export const APP_NAME = 'CRM'
export const PERSIST_STORE_NAME = 'primapro'
export const REDIRECT_URL_KEY = 'redirectUrl'
